import { CompanyClientStatus } from '../enum';
import { CompanyDemoItem, CompanyItem } from '../models';
import { dayjs } from '@core/shared/utils/dayjs';
export var CompanyDemoHelper;
(function (CompanyDemoHelper) {
  function getDemoStatusInfo(obj) {
    let demo;
    let company;
    if (obj instanceof CompanyItem) {
      company = obj;
      demo = obj.demo;
    } else {
      demo = obj;
      company = obj.company;
    }
    if (company?.clientStatus === CompanyClientStatus.Contracted) {
      return {
        icon: 'thumbs-up',
        label: 'Vertragskunde',
        color: 'success'
      };
    }
    if (company?.clientStatus === CompanyClientStatus.Pending) {
      return {
        icon: 'exclamation-triangle',
        label: 'Vertrag ausstehend',
        color: 'danger'
      };
    }
    if (!demo) return {
      icon: undefined,
      label: 'Keine Demo vorhanden'
    };
    if (dayjs().isAfter(demo.endDate)) {
      return {
        icon: 'times',
        label: 'Testphase beendet'
      };
    }
    if (demo.startDate) {
      return {
        icon: 'sync-alt',
        label: 'Testphase seit ' + dayjs(demo.startDate).format('YYYY-MM-DD'),
        color: 'info'
      };
    }
    return {
      icon: 'hourglass',
      label: 'Testphase ausstehend',
      color: 'info'
    };
  }
  CompanyDemoHelper.getDemoStatusInfo = getDemoStatusInfo;
  function calculateEndDate(start) {
    const refDate = start instanceof CompanyDemoItem ? start.expired ? dayjs() : dayjs(start.endDate) : start;
    return dayjs(refDate).add(2, 'weeks').toDate();
  }
  CompanyDemoHelper.calculateEndDate = calculateEndDate;
  function isDemoExpired(demo) {
    return demo.endDate && dayjs().isAfter(demo.endDate);
  }
  CompanyDemoHelper.isDemoExpired = isDemoExpired;
})(CompanyDemoHelper || (CompanyDemoHelper = {}));